import AdminNav from '@/components/admin-nav';
import { admin_setting_path } from '@/rails/routes';
import type { AdminSettingsShow, WorkspacePageProps } from '@/types';
import { Button } from '@astryxdesign/core/Button';
import { Card } from '@astryxdesign/core/Card';
import { Heading } from '@astryxdesign/core/Heading';
import { HStack } from '@astryxdesign/core/HStack';
import { Icon } from '@astryxdesign/core/Icon';
import { NumberInput } from '@astryxdesign/core/NumberInput';
import { Text } from '@astryxdesign/core/Text';
import { VStack } from '@astryxdesign/core/VStack';
import { Form, usePage } from '@inertiajs/react';
import { Settings2 } from 'lucide-react';
import { useMemo, useState } from 'react';
import { useDirtyGuard } from '@/components/dirty-guard';

type Props = WorkspacePageProps & AdminSettingsShow;

const Show = () => {
  const { setting } = usePage<Props>().props;
  const [editableDaysBack, setEditableDaysBack] = useState(setting.editableDaysBack);
  const [planningDaysAhead, setPlanningDaysAhead] = useState(setting.planningDaysAhead);

  const isDirty = useMemo(
    () =>
      editableDaysBack !== setting.editableDaysBack ||
      planningDaysAhead !== setting.planningDaysAhead,
    [editableDaysBack, planningDaysAhead, setting.editableDaysBack, setting.planningDaysAhead]
  );
  // Avisar antes de salir de la configuración con cambios sin guardar.
  useDirtyGuard(isDirty);

  return (
    <VStack gap={6} width="100%" className="iorio-settings-page">
      <AdminNav />

      <Card padding={6} className="iorio-settings-card">
        <Form method="patch" action={admin_setting_path()}>
          {({ processing }) => (
            <VStack gap={5}>
              <VStack gap={2}>
                <HStack gap={2} vAlign="center">
                  <span className="iorio-settings-icon" aria-hidden="true">
                    <Icon icon={Settings2} size="sm" />
                  </span>
                  <Heading level={2}>Ventana de edición</Heading>
                </HStack>
                <Text type="supporting" color="secondary">
                  Cuántos días hacia atrás o adelante puede cada persona tocar sus partes.
                </Text>
              </VStack>

              <HStack gap={4} vAlign="end" wrap="wrap">
                <div className="iorio-settings-field">
                  <NumberInput
                    label="Días editables hacia atrás"
                    htmlName="editable_days_back"
                    value={editableDaysBack}
                    onChange={(value) => setEditableDaysBack(value)}
                    min={0}
                    max={30}
                    isIntegerOnly
                    isRequired
                  />
                </div>

                <div className="iorio-settings-field">
                  <NumberInput
                    label="Días planificables hacia adelante"
                    htmlName="planning_days_ahead"
                    value={planningDaysAhead}
                    onChange={(value) => setPlanningDaysAhead(value)}
                    min={0}
                    max={30}
                    isIntegerOnly
                    isRequired
                  />
                </div>

                <Button label="Guardar" variant="primary" type="submit" isLoading={processing} />
              </HStack>
            </VStack>
          )}
        </Form>
      </Card>
    </VStack>
  );
};

export default Show;
